export abstract class AbstractStorage {
    public abstract getItem<T>(key: string): Promise<T | undefined>;
    public abstract setItem<T>(key: string, value: T): Promise<void>;
    public abstract deleteItem(key: string): Promise<void>;
}
